import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { Container, styled } from '@mui/material'

import { OurStoryCraft } from './components/OurStoryCraft'
import { OurStoryIntro } from './components/OurStoryIntro'
import { OurStoryMission } from './components/OurStoryMission'

export const OurStorySlice: React.FC = () => (
  <StyledContainer maxWidth="md">
    <StyledSection>
      <OurStoryIntro />
    </StyledSection>
    <StyledSection>
      <OurStoryMission />
    </StyledSection>
    {/* <StyledSection>
      <OurStoryTeam />
    </StyledSection> */}
    <StyledSection>
      <OurStoryCraft />
    </StyledSection>
  </StyledContainer>
)

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: pxToRem(60),
  paddingBottom: pxToRem(80),

  [theme.breakpoints.up('md')]: {
    paddingTop: pxToRem(80),
    paddingBottom: pxToRem(100),
  },
}))

const StyledSection = styled('div')(({ theme }) => ({
  marginBottom: theme.sectionGap.xs,

  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.sectionGap.sm,
  },

  '&:last-child': {
    marginBottom: 0,
  },
}))
